import { isReplitUrl } from './isReplitUrl';

/**
 * Opens a blank popup window if the provided URL is a Replit URL.
 * This must be called synchronously during a user action (click) to avoid popup blockers.
 *
 * @param nextUrl - The URL to check if it's a Replit URL
 * @returns The opened popup Window object, or null if not a Replit URL
 */
export const openPopupForReplit = (nextUrl?: string): Window | null => {
  if (nextUrl && isReplitUrl(nextUrl)) {
    return window.open('about:blank', '_blank');
  }
  return null;
};
